import { AnyAction, Dispatch } from 'redux';
import { Language } from 'src/store/users/users.reducer';
import { LocalStorage } from 'src/utils/localStorage';
import { RootState, StoreAction } from '.';
import { MixtureTypes } from './mixtures/mixtures.actions';
import { initialState as initialMixturesState } from './mixtures/mixtures.reducer';
import { ProductTypes } from './products/products.actions';
import { initialState as initialProductsState } from './products/products.reducer';
import { SpecificationTypes } from './specifications/specifications.actions';
import { initialState as initialSpecificationsState } from './specifications/specifications.reducer';
import { UserTypes } from './users/users.actions';
import { initialState as initialUsersState } from './users/users.reducer';

export const USER_LANGUAGE_KEY = 'user_language';
export const PRODUCTS_REQUEST_STATE_KEY = 'products_request_state';
export const MIXTURES_REQUEST_STATE_KEY = 'mixtures_request_state';
export const SPECIFICATIONS_REQUEST_STATE_KEY = 'specifications_request_state';

export const persistStateMiddleware =
  () => (next: Dispatch<AnyAction>) => (action: StoreAction) => {
    if (action.type === UserTypes.ChangeLanguage) {
      LocalStorage.setItem(USER_LANGUAGE_KEY, action.language);
    }

    if (action.type === ProductTypes.UpdateRequestState) {
      LocalStorage.setItem(PRODUCTS_REQUEST_STATE_KEY, action.requestState);
    }

    if (action.type === MixtureTypes.UpdateRequestState) {
      LocalStorage.setItem(MIXTURES_REQUEST_STATE_KEY, action.requestState);
    }

    if (action.type === SpecificationTypes.UpdateRequestState) {
      LocalStorage.setItem(
        SPECIFICATIONS_REQUEST_STATE_KEY,
        action.requestState
      );
    }

    return next(action);
  };

export const recoverState = (): Partial<RootState> => {
  try {
    return {
      users: {
        ...initialUsersState,
        language: LocalStorage.getItem(USER_LANGUAGE_KEY) ?? Language.Norwegian
      },
      products: {
        ...initialProductsState,
        requestState:
          LocalStorage.getItem(PRODUCTS_REQUEST_STATE_KEY) ??
          initialProductsState.requestState
      },
      mixtures: {
        ...initialMixturesState,
        requestState:
          LocalStorage.getItem(MIXTURES_REQUEST_STATE_KEY) ??
          initialMixturesState.requestState
      },
      specifications: {
        ...initialSpecificationsState,
        requestState:
          LocalStorage.getItem(SPECIFICATIONS_REQUEST_STATE_KEY) ??
          initialSpecificationsState.requestState
      }
    };
  } catch (error) {
    return {} as RootState;
  }
};
